module.exports = __webpack_public_path__ + "7a41c8ec.svg";